export const calculateCardWeight = (card, store) => {
  let cardWeight = (store?.physical_store?.card_weight && store.physical_store.card_weight > 0)
    ? store.physical_store.card_weight
    : 5;

  if (store?.physical_store?.use_sleeve && store.physical_store.sleeve_weight > 0) {
    cardWeight += store.physical_store.sleeve_weight;
  }

  return cardWeight * (card.qty || 1);
};


export const createAddressKey = (card) => {
  return [
    card.firstNameReceiver,
    card.lastNameReceiver,
    card.physical?.address_1,
    card.physical?.address_2,
    card.physical?.address_3,
    card.physical?.address_4,
    card.physical?.zip,
    card.physical?.city,
    card.physical?.country
  ].join('_').replace(/[^a-zA-Z0-9_]/g, '-');
};


export const applyDiscountToAmount = (amount, condition, discountType, limit = 0) => {
  if (!condition) return amount;

  let discountAmount = condition.valueType === 'percent'
    ? amount * condition.value / 100
    : condition.value;

  if (limit > 0 && discountAmount > limit) {
    discountAmount = limit;
  }

  return discountType === 'discount'
    ? amount - discountAmount
    : amount + discountAmount;
};


export const isCartDiscountApplicable = (condition, cartTotal) => {
  if (!condition) return false;
  if (condition.thresholdType !== 'cart') return false;
  return condition.amount === 0 || cartTotal >= condition.amount;
};


export const isCardDiscountApplicable = (condition, item) => {
  if (!condition) return false;
  if (condition.thresholdType !== 'card') return false;
  return item.amount >= condition.amount;
};


export const calculateItemDiscountedAmount = (item, condition, discountType) => {
  if (!condition) return item.amount;
  
  if (discountType === "discount") {
    return condition.valueType === 'percent'
      ? item.amount - (item.amount * condition.value / 100)
      : item.amount - condition.value;
  } else {
    return condition.valueType === 'percent'
      ? item.amount + (item.amount * condition.value / 100)
      : item.amount + condition.value;
  }
};


export const calculateBaseCardWeight = (store) => {
  let cardWeight = (store?.physical_store?.card_weight && store.physical_store.card_weight > 0)
    ? store.physical_store.card_weight
    : 5; 

  if (store?.physical_store?.use_sleeve && store.physical_store.sleeve_weight > 0) {
    cardWeight += store.physical_store.sleeve_weight;
  }

  return cardWeight;
};


export const calculateShippingPrice = (delivery, weight) => {
  if (!delivery || !delivery.prices || delivery.prices.length === 0) {
    return 0;
  }

  let selectedPrice = null;
  let maxWeightPrice = null;

  delivery.prices.forEach(price => {
    if (weight <= price.weight && (selectedPrice === null || selectedPrice.weight > price.weight)) {
      selectedPrice = price;
    }
    
    if (maxWeightPrice === null || maxWeightPrice.weight < price.weight) {
      maxWeightPrice = price;
    }
  });

  return selectedPrice === null ? maxWeightPrice.price : selectedPrice.price;
};


export const calculateGroupWeight = (cards, options, cardOptions, baseCardWeight) => {
  let totalWeight = 0;
  
  cards.forEach(card => {
    totalWeight += (card.qty || 1) * baseCardWeight;
  });
  
  if (options) {
    Object.entries(options).forEach(([keyOption, isSelected]) => {
      if (isSelected && cardOptions && cardOptions[keyOption]) {
        totalWeight += cardOptions[keyOption].weight || 0;
      }
    });
  }
  
  return totalWeight;
};


export const isOptionCompatibleWithCardCount = (cardOption, cardCount) => {
  const minCount = cardOption.card_count_min || 1;
  const maxCount = cardOption.card_count_max || Number.MAX_SAFE_INTEGER;
  
  return cardCount >= minCount && cardCount <= maxCount;
};


export const calculateTotalOptionsPrice = (cartOption, physicalStoreOptions) => {
  let totalPrice = 0;
  
  if (!cartOption || !physicalStoreOptions) {
    return totalPrice;
  }
  
  Object.entries(cartOption).forEach(([addressKey, options]) => {
    Object.entries(options).forEach(([optionKey, isSelected]) => {
      if (isSelected && physicalStoreOptions[optionKey]) {
        totalPrice += physicalStoreOptions[optionKey].price || 0;
      }
    });
  });
  
  return totalPrice;
};

export const cartLimitAcheived = (params) => {
  const { store, selectedStore, cart, cartItemsCountMax, qtyToAdd = 0 } = params;
  
  const currentCardsCount = cart.items.reduce((total, item) => {
    return total + (item.qty || 1);
  }, 0);
  
  const totalCards = currentCardsCount + qtyToAdd;
  
  if (selectedStore === 'physical') {
    return store.physical_store?.cart_items_limit > 0 &&
           totalCards > store.physical_store?.cart_items_limit;
  } else {
    const limit = cartItemsCountMax || store?.cartItemsCountMax || 0;
    return limit > 0 && totalCards > limit;
  }
};

export const cartAmountLimitAcheived = (params) => {
  const { store, totalAmounts, cardMontant, qty = 1 } = params;
  const cartAmountMax = store?.cartAmountMax || 0;

  if (cartAmountMax > 0 && cardMontant) {
    const totalAfterAdd = totalAmounts + (Number(cardMontant) * qty);
    return totalAfterAdd > cartAmountMax;
  }

  return false;
};

export const cartMinNotReached = (params) => {
  const { store, cart } = params;
  const cartItemsCountMin = store?.cartItemsCountMin;

  if (cartItemsCountMin != null && cartItemsCountMin > 0) {
    const currentCardsCount = cart.items.reduce((total, item) => {
      return total + (item.qty || 1);
    }, 0);
    return currentCardsCount < cartItemsCountMin;
  }

  return false;
};

export const cartAmountMinNotReached = (params) => {
  const { store, totalAmounts } = params;
  const cartAmountMin = store?.cartAmountMin;

  if (cartAmountMin != null && cartAmountMin > 0) {
    return totalAmounts < cartAmountMin;
  }

  return false;
};